export function RoundText({ children, icon, ...props }) {
  return (
    <div className="relative" {...props}>
      <div className="rotate">{children}</div>
      <div className="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center">{icon}</div>
    </div>
  )
}
